//@flow
import * as React from 'react'
import ExpansionPanel, { ExpansionPanelSummary,ExpansionPanelDetails } from 'material-ui/ExpansionPanel';
import ExpandMore from 'material-ui-icons/ExpandMore'
import Typography from 'material-ui/Typography'
import type { ContainerRowExpandPanel$Props,ContainerRowExpandPanel$State } from './flowTypes'

const styles = ({
    heading: {
        fontSize: 15,
        fontWeight: 500
    },
    headingError: {
        fontSize: 15,
        fontWeight: 700,
        color: 'red'
    }
})

const displayFieldRequireMsg=(noOfErrors:any)=>{
    if (noOfErrors > 0) {
        return ` : *${noOfErrors} ${noOfErrors == 1?'field is mandatory!':'fields are mandatory!'}`
    }else {
        return ''
    }
}

class ContainerRowExpandPanel extends React.Component<ContainerRowExpandPanel$Props,ContainerRowExpandPanel$State> {
    state = {
        expanded: this.props.expanded?this.props.expanded:false,
        timestamp: null
    }
    
    expandOnChange(e:any,expanded:boolean){
        const timestamp = new Date()
        this.setState({expanded,timestamp})
        if (this.props.onChange){
            this.props.onChange(e,expanded)
        }
    }

    render(){
        const canRender = typeof this.props.visible=='undefined'?true:(this.props.visible:any)
        
        let panelHeader = (
            <div className='row' key={`PanelHeader${this.props.elementId}`}>
                <div className="col-sm">
                    <ExpansionPanel expanded={this.props.expanded}  onChange={this.expandOnChange.bind(this)} disabled={this.props.disabled} >
                        <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                            <Typography style={this.props.errors?styles.headingError:styles.heading} >{this.props.title} {displayFieldRequireMsg(this.props.errors)}</Typography>
                        </ExpansionPanelSummary>
                    </ExpansionPanel>
                </div>
            </div>
        )
    
        let elements = []
        
        if (canRender){
            elements.push(panelHeader)
            if (this.state.expanded){
                const panelDetail = (
                    <div className='row' key={`PanelDetail${this.props.elementId}`}>
                        <div className="col-sm">
                            {this.props.children}
                        </div>
                    </div>
                )
                elements.push(panelDetail)
            }
        }
    
        return elements
    }
}

export default ContainerRowExpandPanel


// WEBPACK FOOTER //
// ./src/components/common/ContainerRowExpandPanel.js